import { FC, ReactNode } from 'react';
import styled from 'styled-components';

import { Button } from '@/shared/components';
import { COLORS } from '@/shared/constants/colors';
import { Icon, IconProps } from '@/shared/uikit/Icon';

import { DiagnosticCounter, DiagnosticStatus } from './DiagnosticCounter';

export type InterwillDiagnosticCardProps = {
  count: number;
  status: DiagnosticStatus;
  title: string;
  iconName: IconProps['name'];
  buttonText: string;
  content: ReactNode;
  onBtnClick: () => void;
};

export const InterwillDiagnosticCard: FC<InterwillDiagnosticCardProps> = ({
  count,
  status,
  title,
  iconName,
  buttonText,
  content,
  onBtnClick,
}) => {
  return (
    <Container>
      <InfoContainer>
        <Header>
          <HeaderLeftContainer>
            <IconContainer>
              <Icon name={iconName} />
            </IconContainer>
            <HeaderText>{title}</HeaderText>
          </HeaderLeftContainer>

          <DiagnosticCounter count={count} status={status} />
        </Header>
        <Content>{content}</Content>
      </InfoContainer>

      <Footer>
        <Button text={buttonText} onClick={onBtnClick} block={false} />
      </Footer>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  row-gap: 24px;
  padding: 24px;
  border-radius: 24px;
  background-color: ${COLORS.white};
`;

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;
const Content = styled.div``;
const Footer = styled.div`
  display: flex;
  flex-shrink: 1;
`;

const HeaderLeftContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 44px;
  width: 44px;
  height: 44px;
  background-color: ${COLORS.colorSelectActiveOption};
`;

const HeaderText = styled.div`
  font-size: 16px;
  font-weight: 700;
`;
